import { useMemo } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm, UseFormReturn } from 'react-hook-form';
import * as yup from 'yup';
import { SiteDto } from '../dto/SiteDto';
import { Site } from '../dto/Site';
import { useTranslation } from 'react-i18next';

export function useSitesEditForm(site: Site): UseFormReturn<SiteDto> {
  const { t } = useTranslation();

  return useForm<SiteDto>({
    resolver: useMemo(
      () =>
        yupResolver(
          yup.object().shape({
            name: yup.string().label(t('Name')).required(),
          }),
        ),
      [t],
    ) as any,
    defaultValues: {
      name: site.name,
    },
  });
}
